import { LayoutMetaData } from "../../layout-meta-data/layout-meta-data";
import { Expose, Type } from '@nts/std/serialization';
import { LayoutDefinitionIdentity } from "./layout-definition.identity";
import { AvailableLayoutDtoInterface, LayoutDefinitionIdentityInterface, LayoutMetaDataInterface } from "@nts/std/interfaces";

export class AvailableLayoutDto implements AvailableLayoutDtoInterface {

    constructor() {
        this.identity = new LayoutDefinitionIdentity();
        this.metaData = new LayoutMetaData();
    }

    @Expose()
    @Type(() => LayoutDefinitionIdentity)
    identity: LayoutDefinitionIdentityInterface;

    @Expose()
    isPreferred: boolean;

    @Expose()
    displayName: string;

    @Expose()
    @Type(() => LayoutMetaData)
    metaData: LayoutMetaDataInterface

}
